<div class="config-container">
  <header class="config-header">
    <h1>JSON → JSON 設定</h1>
  </header>

  @if (executeError()) {
    <div class="error-banner">{{ executeError() }}</div>
  }

  <form [formGroup]="configForm" (ngSubmit)="onSubmit()" class="glass-form">
    @if (loading()) {
      <div class="form-loading">
        <div class="loader"></div>
        <p>設定を読み込み中...</p>
      </div>
    } @else {
      <section class="form-section">
        <div class="section-title">
          <span class="icon">📝</span>
          <h2>基本情報</h2>
        </div>
        <div class="grid-fields">
          <div class="form-group span-two">
            <label for="wbsTaskId">
              WBS Task ID (読み込み対象)
              <span class="field-hint">Wbsタスクの構成要素として識別するID</span>
            </label>
            <div class="inline-with-btn">
              <input id="wbsTaskId" type="text" formControlName="wbsTaskId" />
              <button
                type="button"
                class="submit-btn"
                (click)="fetchConfig()"
                [disabled]="loading()"
              >
                {{ loading() ? '...' : '読込' }}
              </button>
            </div>
          </div>
          <div class="form-group">
            <label for="id">
              タスクID
              <span class="field-hint">実行時に指定する固有の識別子</span>
            </label>
            <input id="id" type="text" formControlName="id" placeholder="例: katori-test-task" />
          </div>
          <div class="form-group">
            <label for="name">
              タスク名称
              <span class="field-hint">管理画面などで表示される名前</span>
            </label>
            <input
              id="name"
              type="text"
              formControlName="name"
              placeholder="例: キー名変換タスク"
            />
          </div>
        </div>
      </section>

      <section class="form-section">
        <div class="section-title">
          <span class="icon">🔗</span>
          <h2>問い合わせ先</h2>
        </div>
        <div class="form-group">
          <label for="searchPath">
            検索パス
            <span class="field-hint">データを取得する先のURLまたは定義パス</span>
          </label>
          <div class="input-with-upload">
            <input
              id="searchPath"
              type="text"
              formControlName="searchPath"
              placeholder="https://api.example.com/..."
            />
            <app-file-transfer
              [initialFileId]="configForm.get('searchPath')?.value || ''"
              [compact]="true"
            ></app-file-transfer>
          </div>
        </div>
        <div class="form-group">
          <label for="baseObjectPath">
            基準オブジェクトパス
            <span class="field-hint">結果JSON配列が格納されている階層パス（例: data.list）</span>
          </label>
          <input
            id="baseObjectPath"
            type="text"
            formControlName="baseObjectPath"
            placeholder="例: works"
          />
        </div>
      </section>

      <section class="form-section">
        <div class="section-title">
          <span class="icon">🧩</span>
          <h2>View Schema</h2>
          <span class="section-hint">GUI で編集し、複雑な設定だけ JSON を追加します</span>
        </div>

        <div class="mapping-actions">
          <button
            type="button"
            class="analyze-btn"
            (click)="analyzeJsonKeys()"
            [disabled]="analyzing()"
          >
            @if (analyzing()) {
              <span class="btn-loader"></span> 解析中...
            } @else {
              <span class="icon">🔍</span> JSONからキーを読込
            }
          </button>
        </div>

        <app-view-schema-editor
          formControlName="viewSchemaJson"
          mode="indexApp"
          [fieldKeys]="formulaFieldKeySuggestions()"
        ></app-view-schema-editor>
      </section>

      <footer class="form-footer">
        <button
          type="button"
          class="execute-btn"
          (click)="executeTask()"
          [disabled]="isExecuting()"
        >
          @if (isExecuting()) {
            <span class="btn-loader"></span>実行中...
          } @else {
            ▶ 変換実行
          }
        </button>
        <button type="submit" [disabled]="configForm.invalid || saving()" class="submit-btn">
          @if (saving()) {
            <span class="btn-loader"></span>
            保存中...
          } @else {
            設定を保存
          }
        </button>
      </footer>
    }
  </form>

  @if (hasExecuted()) {
    <section class="results-section glass-form">
      <div class="section-title">
        <span class="icon">✅</span>
        <h2>実行結果</h2>
      </div>
      @if (isLoadingResult()) {
        <div class="results-loading">結果を読み込んでいます...</div>
      } @else if (resultRows().length > 0) {
        <div class="results-header">
          <div class="results-meta">
            <span class="count-badge">{{ resultRows().length }} 件</span>
            <div class="view-switch">
              <button
                type="button"
                class="switch-btn"
                [class.active]="viewMode() === 'table'"
                (click)="viewMode.set('table')"
              >
                テーブル表示
              </button>
              <button
                type="button"
                class="switch-btn"
                [class.active]="viewMode() === 'raw'"
                (click)="viewMode.set('raw')"
              >
                JSON表示
              </button>
            </div>
          </div>
        </div>
        @if (viewMode() === 'table') {
          <div class="table-container glass-card">
            <table class="premium-table">
              <thead>
                <tr>
                  @for (col of getColumns(); track col) {
                    <th>{{ col }}</th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (row of resultRows(); track $index) {
                  <tr>
                    @for (col of getColumns(); track col) {
                      <td>{{ row[col] }}</td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
        } @else {
          <div class="raw-container glass-card">
            <pre>{{ getRawJson() }}</pre>
          </div>
        }
      } @else if (!executeError()) {
        <div class="empty-state glass-card">
          <p>データが返されませんでした。</p>
        </div>
      }
    </section>
  }
</div>
